import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { ActivityTypesEnum } from '../../interfaces/ActivityTypesEnum';

@Directive({
  selector: '[auditOrderRedirectLinkClass]'
})
export class AuditOrderRedirectLinkClassDirective implements OnInit {

  @Input() activityType: any;

  activitiesList: ActivityTypesEnum[] = [
    ActivityTypesEnum.Audit,
    ActivityTypesEnum.Received,
    ActivityTypesEnum.SoldToProvider,
    ActivityTypesEnum.SoldToReverseDistributor,
    ActivityTypesEnum.Returned,
    ActivityTypesEnum.WastedDestroyed,
    ActivityTypesEnum.Compounded
  ];

  constructor(private el: ElementRef, private renderer: Renderer2) {}
  //or simply check orderId/auditId not null
  ngOnInit(): void {
    if (this.activitiesList.includes(this.activityType)) {
      this.renderer.addClass(this.el.nativeElement, 'link');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'link');
    }
  }
}